export class PortlistModel {
  Id: number;
  IsDeleted:boolean;
  CreatedDate:string;
  UpdatedDate :string;      
   CreatedBy:string;        
  ModifiedBy :string;
 PortName :string;
 PortCode:number;      
  PortCountryId :number;
  PortStateId :number;
PortAddress:string;
 ContactName :string;
 PortContact :string;
 CountryCode :string;
  F15 :string;
  IsPortCallRegister:boolean;  
}
